import React from 'react'
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import ResponsiveContainer from 'components/utils/ResponsiveContainer'

const Speakers = ({ list, title }) => {

    list.sort((a,b) => a.Order-b.Order)
    
    return (
        <section>
            <ResponsiveContainer className="py-16">
                <div className="flex flex-col border-b border-solid border-white pb-4 mb-8 md:flex-row md:justify-between md:items-center">
                    <div className="text-center mb-4 md:mb-0 md:text-left">
                        <h6 className="text-optician-sans uppercase text-2xl">{ title }</h6>
                    </div>
                </div>
                <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-5">
                    { list.map( speaker => {
                        const image = getImage(speaker.Photo.localFile)
                        return (
                            <div>
                                <GatsbyImage image={image} alt={speaker.Name} className="w-full" />
                            </div>
                        )
                    }) }
                </div>
            </ResponsiveContainer>
        </section>
    )
}

export default Speakers
